import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
} from "@chakra-ui/react";
import { EmailIcon } from "@chakra-ui/icons";

import { useState } from "react";

const Competiton = () => {
  const [college, setCollege] = useState("");
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const submit = () => {
    console.log("submit");
    setSubmitting(true);
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <Box maxW="300px" height="240px">
        <Alert
          status="success"
          variant="subtle"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          height="200px">
          <AlertIcon boxSize="40px" mr={0} />
          <EmailIcon boxSize="40px" mr={0} />
          <AlertTitle mt={4} mb={1} fontSize="lg">
            Check Your Email!
          </AlertTitle>
          <AlertDescription maxWidth="sm">
            Click the link we've just sent you to confirm your submission.
          </AlertDescription>
        </Alert>
      </Box>
    );
  }

  return (
    <Box maxW="300px" height="240px">
      <FormControl>
        <FormLabel>College / University Name</FormLabel>
        <Input
          value={college}
          onChange={(ev) => setCollege(ev.target.value)}
          placeholder="University of Sadderday"
          mb="20px"
        />
      </FormControl>
      <FormControl>
        <FormLabel>Email Address</FormLabel>
        <Input
          value={email}
          onChange={(ev) => setEmail(ev.target.value)}
          placeholder="info@sadderday.com"
        />
      </FormControl>
      <Button mt="12px" onClick={submit} isLoading={submitting} w="100%">
        Submit Your School
      </Button>
    </Box>
  );
};

export default Competiton;
